<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>         
        <v-layout row wrap>
          <v-flex lg12>          
            <v-card pa-0>              
              <v-toolbar color="teal" dark flat dense cad>
                              
                <v-toolbar-title class="subheading">Option </v-toolbar-title>
                <v-spacer></v-spacer>
                <div class="form-btn">
                    
                    <router-link :to="{path:'/rbac/roles/form', query: {id: formModel.id}}">
                        <v-btn depressed outline icon fab darkcolor="white" small>
                            <v-icon>edit</v-icon>
                        </v-btn>
                    </router-link>                                    
                </div>
              </v-toolbar>
              <v-card-text class="">                                    
                  <v-form v-model="valid">                      
                      <v-layout row wrap>                        
                          <v-flex sm4 lg4>
                                  
                                <v-list two-line>
                                    
                                    <v-list-tile @click="">
                                      <v-list-tile-action>
                                        <v-icon color="indigo">label</v-icon>
                                      </v-list-tile-action>

                                      <v-list-tile-content>
                                        <v-list-tile-title>{{formModel.name}}</v-list-tile-title>
                                        <v-list-tile-sub-title>name</v-list-tile-sub-title>
                                      </v-list-tile-content>
                                     
                                    </v-list-tile>   
                                </v-list>
                          </v-flex>  
                            <v-flex sm4 lg4>
                                  
                                <v-list two-line>        
                                    <v-list-tile @click="">
                                      <v-list-tile-action>
                                        <v-icon color="indigo">reorder</v-icon>
                                      </v-list-tile-action>

                                      <v-list-tile-content>
                                        <v-list-tile-title>{{formModel.description}}</v-list-tile-title>
                                        <v-list-tile-sub-title>description</v-list-tile-sub-title>
                                      </v-list-tile-content>
                                     
                                    </v-list-tile> 
                                </v-list>                                                                                                                                                                                               
                                
                            </v-flex>
                        </v-layout>                                                            
                    </v-form>  
                </v-card-text>
                <v-divider></v-divider>                                
                       <v-layout row wrap>
                        <v-flex lg5 sm5>
                            <v-card pa-0>
                              <v-toolbar card color="white">
                                <v-text-field
                                flat
                                solo
                                prepend-icon="search"
                                placeholder="Type something"
                                v-model="available.search"
                                hide-details
                                class="hidden-sm-and-down"
                                ></v-text-field>                                                    
                              </v-toolbar>
                              <v-divider></v-divider>
                              <v-card-text class="pa-0">
                                <v-data-table
                                  :headers="available.headers"
                                  :search="available.search"
                                  :items="available.items"
                                  :loading="loading"
                                  :pagination.sync="pagination"
                                  :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                                  class="elevation-1"
                                  item-key="name"
                                  select-all                
                                  v-model="available.selected"
                                  >
                                  <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
                                  <template slot="items" slot-scope="props">
                                  <td style="width:5%">
                                    <v-checkbox
                                      primary
                                      hide-details
                                      v-model="props.selected"
                                    ></v-checkbox>
                                  </td>                     
                                    <td>
                                        <v-chip label text-color="white"  :color="color[props.item.type]">
                                        {{ props.item.type }}
                                        </v-chip>
                                    </td>
                                    <td>{{ props.item.name }}</td>                  
                                  </template>
                                </v-data-table>
                              </v-card-text>
                            </v-card>
                        </v-flex>  
                        <v-flex lg2 sm2>
                            <v-btn block :loading="loading" color="success" @click="assign()" dark>Assign >></v-btn>
                            <v-btn block :loading="loading" color="warning" @click="remove()" dark><< Cancel</v-btn>
                        </v-flex>
                        <v-flex lg5 sm5>
                            <v-card pa-0>
                              <v-toolbar card color="white">
                                <v-text-field
                                flat
                                solo
                                prepend-icon="search"
                                placeholder="Type something"
                                v-model="assigned.search"
                                hide-details
                                class="hidden-sm-and-down"
                                ></v-text-field>                                                  
                              </v-toolbar>
                              <v-divider></v-divider>
                              <v-card-text class="pa-0">
                                <v-data-table
                                  :headers="assigned.headers"
                                  :search="assigned.search"
                                  :items="assigned.items"
                                  :loading="loading"
                                  :pagination.sync="pagination"
                                  :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                                  class="elevation-1"
                                  item-key="name"
                                  select-all                
                                  v-model="assigned.selected"
                                  >
                                  <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
                                  <template slot="items" slot-scope="props">
                                  <td style="width:5%">
                                    <v-checkbox
                                      primary
                                      hide-details
                                      v-model="props.selected"
                                    ></v-checkbox>
                                  </td>                  
                                    <td>
                                        <v-chip label text-color="white"  :color="color[props.item.type]">
                                        {{ props.item.type }}
                                        </v-chip>
                                    </td>
                                    <td>{{ props.item.name }}</td>
                                    
                                  </template>
                                </v-data-table>
                              </v-card-text>
                            </v-card>
                        </v-flex>  
                        </v-layout>                                                    
                        
            </v-card>
          </v-flex>                   
        </v-layout>
      </v-container>        
    </div>
    
  </v-slide-y-transition>
</template>
<script>     
import Role from '@/apps/main/models/rbac/Role';
import moment from 'moment';

var model = new Role();

export default {
    $_veeValidate: {
        validator: 'new'
    },    
    data: () => ({        
        valid:true,
        active: null,
        pagination:{},
        isUpdate:false, 
        color : {
            role:'teal',
            permission:'cyan',
            route:'grey'
        },
        formModel: {
            id: null,
            name:null,
            description:null,
        },
        available  : {
            search : '',
            selected: [],
            headers: [              
                { text: 'Type', value: 'type', align:'left'}, 
                { text: 'Name', value: 'name', align:'left'},                            
            ],
            items: []
        },
        assigned : {
            search  : '',
            selected: [],
            headers: [              
                { text: 'Type', value: 'type', align:'left'}, 
                { text: 'Name', value: 'name', align:'left'},                            
            ],
            items: []
        },
        loading  : true,
    }),
        
    created () {},    
    mounted () {
        this.init();        
    }, 
    methods : {
        
        
        init(){            
            if(this.$route.query.id){
                this.isUpdate  = true;
                model.one({id : this.$route.query.id }).then(data => {                      
                    Object.assign(this.formModel, data === null ? {}:data);                                  
                    this.formModel.id = this.formModel.name;                                                                                
                    this.getView();
                });                                               
            }            
            this.$validator.localize('en', this.dictionary);       
        },
        
        getView(){
            model.view({id:this.formModel.id}).then(data=>{   
                var data = data.data;
                this.available.items = [];
                this.assigned.items = [];
                for(var key in data.available){                
                    this.available.items.push({name:key, type:data.available[key]});
                }  
                for(var key in data.assigned){                
                    this.assigned.items.push({name:key,type:data.assigned[key]});
                }  
                this.loading = false;
            })
        },
        
        assign(){
            var arr = [];
            this.available.selected.forEach((item)=>{
                arr.push(item.name);
            });
            this.loading = true;
            model.assign({items:arr}, {id:this.formModel.id}).then(data =>{                
                this.init();
            });
        },
                
        remove(){
            var arr = [];
            this.assigned.selected.forEach((item)=>{
                arr.push(item.name);
            });
            this.loading = true;
            model.remove({items:arr}, {id:this.formModel.id}).then(data =>{                
                this.init();
            });
        },
    }
}
</script>